import React, { useEffect, useRef, useState } from "react";
import { onboardingServices } from "../../services/onboardingServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { getFileNameByPath, isEmptyDash } from "../../constant";
import { isRequiredValid } from "./isRequired";
import _ from "lodash";
import FileViewerModal from '../common/viewModal.js';
import MediaListModal from "../common/mediaListModal.js";
import { isClearformVaild } from "./isClearform";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

function OnboardingStepThree(props) {
  const fileRef = useRef([]);
  let navigate = useNavigate();
  const navigateUrl = (url) => {
    navigate(url);
  }
  const [open, setOpen] = React.useState(false);
  const [formStepFieldsDetails, setFormStepFieldsDetails] = React.useState({
    sections: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [fileSrc, setFileSrc] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [uploadFilesObj, setUploadFilesObj] = useState({});

  // const handleClick = (id) => {
  //   let filterData = fileRef.current.filter(ele => ele?.id == id); 
  //   filterData[0].click();
  // }

  const handleClick = (ele, isChild, headName, i, j, idx) => {
    // let filterData = fileRef.current.filter(ele => ele?.id == id); 
    // filterData[0].click();
    ele.isChild = isChild;
    ele.headName = headName;
    ele.isUploadOption = true;
    ele.i = i;
    ele.j = j;
    ele.idx = idx;
    setUploadFilesObj(ele);
    setIsMediaListModalOpen(true);
  }
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };
  const onUploadMedia = (resData, uploadObj, files) => {
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
    let obj = {
      //  key: resData?.data?.key, 
      key: encodeKey(resData?.data?.Key),
      name: files?.name
    };
    // formStepFieldsDetailsInitial.sections[idx].fields[i].child[j].childAnswer;

    if (uploadObj?.isChild === true) {
      formStepFieldsDetailsInitial.sections[uploadObj?.idx].fields[uploadObj?.i].child[uploadObj?.j].files.push(obj);
    }
    else {
      formStepFieldsDetailsInitial.sections[uploadObj?.idx].fields[uploadObj?.i]?.files.push(obj);
    }
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);


  };


  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };

  useEffect(() => {
    let formStepFieldsDetailsInit = _.cloneDeep(props?.formStepFieldsDetails);
    let newArr = formStepFieldsDetailsInit.sections.filter(ele => ele.viewAccess == true);
    formStepFieldsDetailsInit.sections = [...newArr];

    if (props?.formStepFieldsDetails?._id == "65dda2f43e446a7c0e67c9f6") {
      setFormStepFieldsDetails(formStepFieldsDetailsInit);
    }
  }, [props?.formStepFieldsDetails]);

  useEffect(() => {
    if (props?.formStepFieldsDetails?._id === "65dda2f43e446a7c0e67c9f6") {
      let details = _.cloneDeep(props?.formStepFieldsDetails);
      let newArr = details.sections.filter(ele => ele.viewAccess === true);
      details.sections = [...newArr];
      for (let i = 0; i < details?.sections.length; i++) {
        for (let j = 0; j < details?.sections[i]?.fields.length; j++) {
          if (details?.sections[i]?.fields[j].type === "MultiField") {
            details?.sections[i]?.fields[j].child.sort((a, b) => a._id.localeCompare(b._id));
            if (details?.sections[i]?.fields[j].isCopied === true) {
              for (let k = 0; k < details?.sections[i]?.fields[j].child.length; k++) {
                if (details?.sections[i]?.fields[j].child[k].type === "File") {
                  details.sections[i].fields[j].child[k].isEdit = true;
                } else {
                  details.sections[i].fields[j].child[k].isEdit = false;
                }
              }
            }
          }
        }
      }
      setFormStepFieldsDetails(details);
    }
  }, [props?.formStepFieldsDetails]);

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const uploadFile = (e, ele, i, idx) => {
    e.preventDefault();
    let formData = new FormData();
    let files = e.target.files[0]
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success == true) {
          setUrl(response?.data?.data, ele, i, idx, files);
          // formStepFieldsDetailsInitial[i].answer = e.target.value;
          // setFormStepFieldsDetails(formStepFieldsDetailsInitial);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const onTextChange = (e, ele, idx, i) => {
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
    formStepFieldsDetailsInitial.sections[idx].fields[i].answer =
      e.target.value;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial.sections[idx].fields[i].errMsg = '';
  };

  const onMultiObjTextChange = (e, ele, i, idx, multiFieldEle, j, fielsNum) => {
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
    let childAnswer =
      formStepFieldsDetailsInitial.sections[idx].fields[i].child[j].childAnswer;
    if (isEmptyDash(childAnswer)) {
      childAnswer = "->";
    }
    let splitAns = childAnswer.split("->");
    splitAns[fielsNum] = e.target.value;
    let str = `${splitAns[0]}->${splitAns[1]}`;
    formStepFieldsDetailsInitial.sections[idx].fields[i].child[j].childAnswer =
      str;
    // formStepFieldsDetailsInitial.sections[idx].fields[i].answer = e.target.value;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  };
  const onSelectChange = (e, ele, idx, i) => {
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };

    formStepFieldsDetailsInitial.sections[idx].fields[i].optionId =
      e.target.value;
    if (ele.name === 'Bank Country') {
      let nextField = formStepFieldsDetailsInitial.sections[idx]?.fields[i + 1];

      if (nextField) {
        if (!nextField.originalOptions) {
          nextField.originalOptions = [...nextField.options];
        }
        nextField.options = nextField.originalOptions.filter(item => item.dependentOptionId === e.target.value);
        const previousOptionId = formStepFieldsDetails.sections[idx].fields[i + 1]?.optionId;
        if (previousOptionId && !nextField.options.some(option => option.id === previousOptionId)) {
          formStepFieldsDetailsInitial.sections[idx].fields[i + 1].optionId = '';
        }
      }

    }
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial.sections[idx].fields[i].errMsg = '';
  };
  // const onSelectChange = (e, ele, idx, i) => {
  //   let formStepFieldsDetailsInitial = { ...formStepFieldsDetails }; 
  //   formStepFieldsDetailsInitial.sections[idx].fields[i].optionId =
  //     e.target.value;
  //   setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  // };

  const onMultiSelectChange = (e, ele, i, idx, multiFieldEle, j) => {
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
    formStepFieldsDetailsInitial.sections[idx].fields[i].child[j].optionId =
      e.target.value;
    // formStepFieldsDetailsInitial[i].child[j].optionId = e.target.value;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial.sections[idx].fields[i].child[j].errMsg = '';
  };

  const onMultiTextChange = (e, ele, i, idx, multiFieldEle, j) => {
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
    formStepFieldsDetailsInitial.sections[idx].fields[i].child[j].childAnswer =
      e.target.value;
    // formStepFieldsDetailsInitial[i].child[j].childAnswer = e.target.value;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial.sections[idx].fields[i].errMsg = '';

  };

  const setUrl = (data, ele, i, idx, files) => {
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
    let obj = {
      // key: data?.data?.key,
      key: encodeKey(data?.data?.Key),
      name: files?.name
    };
    // formStepFieldsDetailsInitial.sections[idx].fields[i].answer =
    //   data?.data?.Key;
    formStepFieldsDetailsInitial.sections[idx].fields[i].files[0] = obj;
    // formStepFieldsDetailsInitial[i].answer = data?.data?.Key;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial.sections[idx].fields[i].errMsg = '';

  };

  const isFieldDisable = (propDisable, isEdit) => {
    let disabled = true;
    if (propDisable == false && isEdit == true) {
      disabled = false;
    }
    return disabled;
  };

  const uploadMultiChildFile = (e, ele, i, idx, multiFieldEle, j) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    let files = e.target.files[0]
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success == true) {
          setMultiChildUrl(response?.data?.data, ele, i, idx, multiFieldEle, j, files);
          // formStepFieldsDetailsInitial[i].answer = e.target.value;
          // setFormStepFieldsDetails(formStepFieldsDetailsInitial);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const setMultiChildUrl = (data, ele, i, idx, multiFieldEle, j, files) => {
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
    let obj = {
      // key: data?.data?.key,
      key: encodeKey(data?.data?.Key),
      name: files?.name
    };
    formStepFieldsDetailsInitial.sections[idx].fields[i].child[j].files[0] = obj;
    // let obj = {
    //   "childquestionId": multiFieldEle?._id,
    //   "childAnswer": data?.data?.Key,
    //   "optionId": null,
    // };
    // let obj = {
    //   key: data?.data?.key,
    //   name: files?.name
    // }; 
    // formStepFieldsDetailsInitial[i].child[j].files[0] = [obj];
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  };

  const submitForm = () => {
    let bodyDataStepThree = {
      isEdit: false,
      stepId: formStepFieldsDetails?._id,
      formData: {
        _id: formStepFieldsDetails?._id,
        sections: [...formStepFieldsDetails?.sections],
        viewAccess: formStepFieldsDetails?.viewAccess,
        editAccess: formStepFieldsDetails?.editAccess,
        stepName: formStepFieldsDetails?.stepName,
        createdAt: "2024-02-27T08:53:08.006Z",
        updatedAt: "2024-03-06T16:16:18.564Z",
        __v: 31,
      },
    };
    if (isRequiredValid(bodyDataStepThree?.formData?.sections)?.isValid) {

      props.submitForm(bodyDataStepThree);
    } else {
      let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
      formStepFieldsDetailsInitial.sections = [...isRequiredValid(bodyDataStepThree?.formData?.sections)?.sections];
      setFormStepFieldsDetails(formStepFieldsDetailsInitial);
      openAlert(true, "error", `Please fill all required fields.`);
    }

    // props.submitForm(bodyDataStepThree);
  };


  const openModal = (src) => {
    setFileSrc(src);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setFileSrc();
    setIsModalOpen(false);
  };
  function getFileExtension(filename) {
    return filename.split('.').pop();
  }
  const viewMedia = (data) => {
    // openModal()
    onboardingServices
      .viewUrlData(data).then(function (response) {
        setFileSrc(response?.data?.data?.url)
        const url = response?.data?.data?.url;
        const filename1 = url.substring(url.lastIndexOf('/') + 1);
        const filename = filename1.split('?')[0];
        const extension = getFileExtension(filename);
        if (extension && extension !== 'png' && extension !== 'jpg' && extension !== 'jpeg') {
          setIsModalOpen(false)
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", getFileNameByPath(data));
          document.body.appendChild(link);
          link.click();
        } else {
          setIsModalOpen(true)
        }
      })
  };

  const clearForm = () => {
    // props.onColumnClk(props?.formStepFieldsDetails, 0);   
    let details = _.cloneDeep(formStepFieldsDetails);
    const data = isClearformVaild(details.sections)
    details.sections = [...data];
    setFormStepFieldsDetails(details);
  }

  const deleteFile = (index, key, idx) => {
    const updatedFiles = uploadFilesObj.files.filter((file, i) => i !== index);
    setUploadFilesObj({ ...uploadFilesObj, files: updatedFiles });
    let formStepFieldsDetailsInitial = { ...formStepFieldsDetails };
    // if (uploadFilesObj?.files?.isChild === true) {
    if (uploadFilesObj?.isChild === true) {
      // formStepFieldsDetailsInitial.child[uploadFilesObj?.j].files = updatedFiles;
      formStepFieldsDetailsInitial.sections[idx].fields[uploadFilesObj?.i].child[uploadFilesObj?.j].files = updatedFiles;
    } else {
      // formStepFieldsDetailsInitial.files = updatedFiles;
      formStepFieldsDetailsInitial.sections[idx].fields[uploadFilesObj?.i].files = updatedFiles;
    }
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  };

  return (
    <div>
      {formStepFieldsDetails.sections.map((secEle, idx) => (
        <>
          <div className="form_white-outer">
            <h2 className="lets_text_onboarding_form">{secEle?.title}</h2>

            <div className="must_fill">
              <span>*</span> You must fill in all fields to be able to continue
            </div>

            <div className="row">
              {secEle?.fields.map((ele, i) => (
                <>
                  {ele.type == "Dropdown" && ele?.display == true && (
                    <div className="col-md-6 lets_onboarding_wizard_react">
                      <div className="input_outer">
                        <label className="mb-1 text-dark">
                          {ele?.name}
                          {ele?.required && <span className="required">*</span>}
                        </label>

                        <select
                          className="form-select w-100"
                          aria-label="Default select example"
                          disabled={props?.isDisable}
                          onChange={(e) => onSelectChange(e, ele, idx, i)}
                          value={ele?.optionId}
                        >
                          <option value={"null"} disabled selected>
                            Please Select
                          </option>
                          {ele?.options.map((optionEle, i) => (
                            <>
                              <option value={optionEle?._id}>
                                {optionEle?.optionName}
                              </option>
                            </>
                          ))}
                        </select>
                        <span id="businessNameError" className="error">{ele?.errMsg}</span>
                      </div>
                    </div>
                  )}

                  {ele.type == "String" && ele?.display == true && (
                    <div className="col-md-6 lets_onboarding_wizard_react">
                      <div className="input_outer">
                        <label className="mb-1 text-dark">
                          {ele?.name}
                          {ele?.required && <span className="required">*</span>}
                        </label>
                        <input
                          type="text"
                          className="form-control ob-form-text-input form-h"
                          id="businessName"
                          value={ele?.answer}
                          onChange={(e) => onTextChange(e, ele, idx, i)}
                          disabled={props?.isDisable}
                        />
                        <span id="businessNameError" className="error">{ele?.errMsg}</span>
                      </div>
                    </div>
                  )}

                  {ele.type == "File" && ele?.display == true && (
                    <div className="col-md-6 lets_onboarding_wizard_react">
                      <div className="input_outer">
                        <label className="mb-1 text-dark">
                          {ele?.name}
                          {ele?.required && <span className="required">*</span>}
                        </label>

                        <div class="upload-sec-file 122313">
                          {/* <div>

                              </div> */}
                          {(!isEmptyDash(ele.files[0])) && <> <div className="selected-file-present-div">{ }

                            <span className="selected-file-present-text">Document: {ele?.files?.length}</span>
                            {/* <img src={FilePresent} style={{ height: '24px', cursor: 'pointer' }} onClick={() => viewMedia(ele?.files[0].key)} alt="" /> */}
                            {/* <span className="selected-file-present-text">{ele.files[0].name}</span> */}
                          </div>
                            <button className="file-upload-btn"
                              //  disabled={props?.isDisable} 
                              onClick={() => handleClick(ele, false, ele?.name, i, -1, idx)}>View</button>
                          </>
                          }
                          <input
                            ref={ref => !fileRef.current.includes(ref) && fileRef.current.push(ref)}
                            // ref={fileRef}
                            className="form-control form-h choose"
                            type="file"
                            accept={ele?.validation[0]?.fileTypes}
                            id={ele?.questionId}
                            onChange={(e) => uploadFile(e, ele, i, idx)}
                            disabled={props?.isDisable}
                            style={isEmptyDash(ele.files[0]) ? { display: 'block' } : { display: 'none' }}
                          />
                        </div>
                        {/* <div class="mb-3">
                          <input
                            className="form-control form-h choose"
                            type="file"
                            id=""
                            onChange={(e) => uploadFile(e, ele, i, idx)}
                            disabled={props?.isDisable}
                          />
                        </div> */}
                        <span id="businessNameError" className="error">{ele?.errMsg}</span>
                      </div>
                    </div>
                  )}

                  {/* For Conditional MultiField */}
                  {(ele.type == "MultiField" && ele.isConditional == true) && ele?.display == true && (
                    <div className="col-md-6 lets_onboarding_wizard_react">
                      <div className="row">
                        {ele?.child.map((multiFieldEle, j) => (
                          <>
                            {(multiFieldEle.type == "Dropdown" && (ele.optionId == multiFieldEle.refOptionId || multiFieldEle.isDeciding == true)) && (
                              <div className={(multiFieldEle.isDeciding == true && isEmptyDash(ele.optionId)) ? `col-md-12 lets_onboarding_wizard_react` : `col-md-6 lets_onboarding_wizard_react`}>
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {multiFieldEle?.name}
                                    {(ele?.required && multiFieldEle.isDeciding == true) && (
                                      <span className="required">*</span>
                                    )}
                                  </label>

                                  <select
                                    className="form-select w-100"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      onMultiSelectChange(
                                        e,
                                        ele,
                                        i,
                                        idx,
                                        multiFieldEle,
                                        j
                                      )
                                    }
                                    value={multiFieldEle?.optionId}
                                    disabled={isFieldDisable(props?.isDisable, multiFieldEle?.isEdit)}
                                  >
                                    <option
                                      value={"null"}
                                      disabled
                                      selected
                                    >
                                      Please Select
                                    </option>
                                    {multiFieldEle?.options.map(
                                      (optionEle, i) => (
                                        <>
                                          <option value={optionEle?._id}>
                                            {optionEle?.optionName}
                                          </option>
                                        </>
                                      )
                                    )}
                                  </select>
                                </div>
                              </div>
                            )}

                            {(multiFieldEle.type == "String" && ele.optionId == multiFieldEle.refOptionId) && (
                              <div className="col-md-6 lets_onboarding_wizard_react">
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {multiFieldEle?.name}
                                    {/* {ele?.required && (
                                          <span className="required">*</span>
                                        )} */}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control ob-form-text-input form-h"
                                    id="businessName"
                                    value={multiFieldEle?.childAnswer}
                                    onChange={(e) =>
                                      onMultiTextChange(
                                        e,
                                        ele,
                                        i,
                                        multiFieldEle,
                                        j
                                      )
                                    }
                                    disabled={isFieldDisable(props?.isDisable, multiFieldEle?.isEdit)}
                                  />
                                  <span
                                    id="businessNameError"
                                    className="error"
                                  ></span>
                                </div>
                              </div>
                            )}

                            {(multiFieldEle.type == "File" && ele.optionId == multiFieldEle.refOptionId) && (
                              <div className="col-md-6 lets_onboarding_wizard_react">
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {multiFieldEle?.name}
                                    {/* {(ele?.required) && <span className="required">*</span>} */}
                                  </label>

                                  <div class="mb-3 upload-sec-files_docyment">
                                    {(!isEmptyDash(multiFieldEle?.files[0]?.key)) && <> <div className="selected-file-present-div">{ }
                                      {/* <img src={FilePresent} style={{ height: '24px' }} /> */}
                                      <span className="selected-file-present-text">Document: {multiFieldEle?.files?.length}</span>
                                    </div>
                                      <button className="file-upload-btn"
                                        //  disabled={props?.isDisable}
                                        onClick={() => handleClick(multiFieldEle, true, ele?.name, i, j, idx)}>View</button>
                                    </>
                                    }
                                    <input
                                      ref={ref => !fileRef.current.includes(ref) && fileRef.current.push(ref)}
                                      // ref={fileRef}
                                      className="form-control form-h choose"
                                      type="file"
                                      accept={ele?.validation[0]?.fileTypes}
                                      id={ele?.questionId}
                                      onChange={(e) => uploadMultiChildFile(e, ele, i, idx, multiFieldEle, j)}
                                      disabled={isFieldDisable(props?.isDisable, multiFieldEle?.isEdit)}
                                      style={isEmptyDash(multiFieldEle?.files[0]?.key) ? { display: 'block' } : { display: 'none' }}
                                    />
                                  </div>

                                  {/* <div class="mb-3">
                                        <input
                                          className="form-control form-h choose"
                                          type="file"
                                          accept={ele?.validation[0]?.fileTypes}
                                          id=""
                                          onChange={(e) =>
                                            uploadMultiChildFile(
                                              e,
                                              ele,
                                              i,
                                              multiFieldEle,
                                              j
                                            )
                                          }
                                          disabled={props?.isDisable}
                                        />
                                      </div> */}
                                  <span
                                    id="businessNameError"
                                    className="error"
                                  ></span>
                                </div>
                              </div>
                            )}

                            {multiFieldEle.type == "Object" && (
                              <>
                                <div>
                                  <label className="">
                                    {ele?.name}
                                  </label>
                                </div>
                                <div className="col-md-6 lets_onboarding_wizard_react">
                                  <div className="">
                                    <input
                                      type="text"
                                      className="form-control ob-form-text-input form-h"
                                      id="businessName"
                                      placeholder={multiFieldEle?.name}
                                      value={
                                        isEmptyDash(
                                          multiFieldEle?.childAnswer
                                        )
                                          ? ""
                                          : multiFieldEle?.childAnswer.split(
                                            "->"
                                          )[0]
                                      }
                                      onChange={(e) =>
                                        onMultiObjTextChange(
                                          e,
                                          ele,
                                          i,
                                          idx,
                                          multiFieldEle,
                                          j,
                                          0
                                        )
                                      }
                                      disabled={props?.isDisable}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 lets_onboarding_wizard_react">
                                  <div className="">
                                    <input
                                      type="text"
                                      className="form-control ob-form-text-input form-h"
                                      id="businessName"
                                      placeholder="Value"
                                      value={
                                        isEmptyDash(
                                          multiFieldEle?.childAnswer
                                        )
                                          ? ""
                                          : multiFieldEle?.childAnswer.split(
                                            "->"
                                          )[1]
                                      }
                                      onChange={(e) =>
                                        onMultiObjTextChange(
                                          e,
                                          ele,
                                          i,
                                          idx,
                                          multiFieldEle,
                                          j,
                                          1
                                        )
                                      }
                                      disabled={props?.isDisable}
                                    />
                                    <span
                                      id="businessNameError"
                                      className="error"
                                    ></span>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        ))}
                      </div>
                      <span id="businessNameError" className="error">{ele?.errMsg}</span>
                    </div>
                  )}

                  {/* For Without Conditional MultiField */}
                  {(ele.type == "MultiField" && ele.isConditional != true) && ele?.display == true && (

                    <div className="col-md-6">
                      {(ele?.child[0].type == "Object") && <label style={{ marginBottom: "10px " }}>
                        {ele?.name}
                        {ele?.required && (
                          <span className="required">*</span>
                        )}
                      </label>}

                      <div className="row">
                        {ele?.child.map((multiFieldEle, j) => (
                          <>
                            {multiFieldEle.type == "Dropdown" && (
                              <div className="col-md-6 lets_onboarding_wizard_react">
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {multiFieldEle?.name}
                                    {ele?.required && (
                                      <span className="required">*</span>
                                    )}
                                  </label>

                                  <select
                                    className="form-select w-100"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      onMultiSelectChange(
                                        e,
                                        ele,
                                        i,
                                        idx,
                                        multiFieldEle,
                                        j
                                      )
                                    }
                                    value={multiFieldEle?.optionId}
                                    disabled={props?.isDisable}
                                  >
                                    <option
                                      value={"null"}
                                      disabled
                                      selected
                                    >
                                      Please Select
                                    </option>
                                    {multiFieldEle?.options.map(
                                      (optionEle, i) => (
                                        <>
                                          <option value={optionEle?._id}>
                                            {optionEle?.optionName}
                                          </option>
                                        </>
                                      )
                                    )}
                                  </select>
                                </div>
                              </div>
                            )}

                            {(multiFieldEle.type == "String" && ele.optionId == multiFieldEle.refOptionId) && (
                              <div className="col-md-6 lets_onboarding_wizard_react">
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {multiFieldEle?.name}
                                    {ele?.required && (
                                      <span className="required">*</span>
                                    )}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control ob-form-text-input form-h"
                                    id="businessName"
                                    value={multiFieldEle?.childAnswer}
                                    onChange={(e) =>
                                      onMultiTextChange(
                                        e,
                                        ele,
                                        i,
                                        idx,
                                        multiFieldEle,
                                        j
                                      )
                                    }
                                    disabled={props?.isDisable}
                                  />
                                  <span
                                    id="businessNameError"
                                    className="error"
                                  ></span>
                                </div>
                              </div>
                            )}

                            {(multiFieldEle.type == "File") && (
                              <div className="col-md-6 lets_onboarding_wizard_react">
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {multiFieldEle?.name}
                                    {/* {(ele?.required) && <span className="required">*</span>} */}
                                  </label>

                                  <div class="mb-3 upload-sec-file">
                                    {(!isEmptyDash(multiFieldEle?.files[0]?.key)) && <> <div className="selected-file-present-div">{ }
                                      {/* <img src={FilePresent} style={{ height: '24px' }} /> */}
                                      <span className="selected-file-present-text">Document: {multiFieldEle?.files?.length}</span>
                                    </div>
                                      <button className="file-upload-btn" disabled={props?.isDisable} onClick={() => handleClick(multiFieldEle, true, ele?.name, i, j, idx)}>View</button>
                                    </>
                                    }
                                    <input
                                      ref={ref => !fileRef.current.includes(ref) && fileRef.current.push(ref)}
                                      // ref={fileRef}
                                      className="form-control form-h choose"
                                      type="file"
                                      accept={ele?.validation[0]?.fileTypes}
                                      id={ele?.questionId}
                                      onChange={(e) => uploadMultiChildFile(e, ele, i, idx, multiFieldEle, j)}
                                      disabled={props?.isDisable}
                                      style={isEmptyDash(multiFieldEle?.files[0]?.key) ? { display: 'block' } : { display: 'none' }}
                                    />
                                  </div>
                                  <span
                                    id="businessNameError"
                                    className="error"
                                  ></span>
                                </div>
                              </div>
                            )}

                            {multiFieldEle.type == "Object" && (
                              <>
                                <div className="col-md-6 lets_onboarding_wizard_react">

                                  <div className="">
                                    <input
                                      type="text"
                                      className="form-control ob-form-text-input form-h"
                                      id="businessName"
                                      placeholder={multiFieldEle?.name}
                                      value={
                                        isEmptyDash(
                                          multiFieldEle?.childAnswer
                                        )
                                          ? ""
                                          : multiFieldEle?.childAnswer.split(
                                            "->"
                                          )[0]
                                      }
                                      onChange={(e) =>
                                        onMultiObjTextChange(
                                          e,
                                          ele,
                                          i,
                                          idx,
                                          multiFieldEle,
                                          j,
                                          0
                                        )
                                      }
                                      disabled={props?.isDisable}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 lets_onboarding_wizard_react">
                                  <div className="">
                                    <input
                                      type="text"
                                      className="form-control ob-form-text-input form-h"
                                      id="businessName"
                                      placeholder="Value"
                                      value={
                                        isEmptyDash(
                                          multiFieldEle?.childAnswer
                                        )
                                          ? ""
                                          : multiFieldEle?.childAnswer.split(
                                            "->"
                                          )[1]
                                      }
                                      onChange={(e) =>
                                        onMultiObjTextChange(
                                          e,
                                          ele,
                                          i,
                                          idx,
                                          multiFieldEle,
                                          j,
                                          1
                                        )
                                      }
                                      disabled={props?.isDisable}
                                    />
                                    <span
                                      id="businessNameError"
                                      className="error"
                                    ></span>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        ))}
                      </div>
                      <span id="businessNameError" className="error">{ele?.errMsg}</span>
                    </div>
                  )}

                  {/* {ele.type == "MultiField" && ele?.display == true && (
                    <div className="col-md-6">
                      <label style={{ marginBottom: "10px" }} className="mb-1 text-dark">
                        {ele?.name}
                        {ele?.required && (
                          <span className="required">*</span>
                        )}
                      </label>
                      <div className="row">
                        {ele?.child.map((multiFieldEle, j) => (
                          <>
                            {multiFieldEle.type == "Dropdown" && (
                              <div className="col-md-6 lets_onboarding_wizard_react">
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {multiFieldEle?.name}
                                    {ele?.required && (
                                      <span className="required">*</span>
                                    )}
                                  </label>

                                  <select
                                    className="form-select w-100"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      onMultiSelectChange(
                                        e,
                                        ele,
                                        i,
                                        idx,
                                        multiFieldEle,
                                        j
                                      )
                                    }
                                    value={multiFieldEle?.optionId}
                                    disabled={props?.isDisable}
                                  >
                                    <option value={"null"} disabled selected>
                                      Please Select
                                    </option>
                                    {multiFieldEle?.options.map(
                                      (optionEle, i) => (
                                        <>
                                          <option value={optionEle?._id}>
                                            {optionEle?.optionName}
                                          </option>
                                        </>
                                      )
                                    )}
                                  </select>
                                </div>
                                <span id="businessNameError" className="error">{ele?.errMsg}</span>
                              </div>
                            )}

                            {multiFieldEle.type == "String" && (
                              <div className="col-md-6 lets_onboarding_wizard_react">
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {multiFieldEle?.name}
                                    {ele?.required && (
                                      <span className="required">*</span>
                                    )}
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control ob-form-text-input form-h"
                                    id="businessName"
                                    value={multiFieldEle?.childAnswer}
                                    disabled={props?.isDisable}
                                    onChange={(e) =>
                                      onMultiTextChange(
                                        e,
                                        ele,
                                        i,
                                        idx,
                                        multiFieldEle,
                                        j
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            )}

                            {multiFieldEle.type == "Object" && (
                              <>
                                <div className="col-md-6 lets_onboarding_wizard_react">
                                  <div className="">
                                    <label className="mb-1 text-dark">
                                      {multiFieldEle?.name}
                                      {ele?.required && (
                                        <span className="required">*</span>
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ob-form-text-input form-h"
                                      id="businessName"
                                      disabled={props?.isDisable}
                                      value={
                                        isEmptyDash(multiFieldEle?.childAnswer)
                                          ? ""
                                          : multiFieldEle?.childAnswer.split(
                                            "->"
                                          )[0]
                                      }
                                      onChange={(e) =>
                                        onMultiObjTextChange(
                                          e,
                                          ele,
                                          i,
                                          idx,
                                          multiFieldEle,
                                          j,
                                          0
                                        )
                                      }
                                    />
                                    <span id="businessNameError" className="error">{ele?.errMsg}</span>
                                  </div>
                                </div>
                                <div className="col-md-6 lets_onboarding_wizard_react">
                                  <div className="">
                                    <label className="mb-1 text-dark">
                                      Value
                                      {ele?.required && (
                                        <span className="required">*</span>
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ob-form-text-input form-h"
                                      id="businessName"
                                      // value={multiFieldEle?.childAnswer}
                                      disabled={props?.isDisable}
                                      onChange={(e) =>
                                        onMultiObjTextChange(
                                          e,
                                          ele,
                                          i,
                                          idx,
                                          multiFieldEle,
                                          j,
                                          1
                                        )
                                      }
                                    />
                                    <span
                                      id="businessNameError"
                                      className="error"
                                    ></span>
                                  </div>
                                </div>
                              </>
                            )}

                            {multiFieldEle.type == "File" && (
                              <div className="col-md-6 lets_onboarding_wizard_react">
                                <div className="">
                                  <label className="mb-1 text-dark">
                                    {ele?.name}
                                    {(ele?.required) && <span className="required">*</span>}
                                  </label>

                                  <div class="mb-3 upload-sec-file">
                                    {(!isEmptyDash(multiFieldEle?.files[0]?.key)) && <> <div className="selected-file-present-div">{ }
                                     
                                      <span className="selected-file-present-text">Document: {multiFieldEle?.files?.length}</span>
                                    </div>
                                      <button className="file-upload-btn" disabled={props?.isDisable} onClick={() => handleClick(multiFieldEle, true, ele?.name, i, j, idx)}>View</button>
                                    </>
                                    }
                                    <input
                                      ref={ref => !fileRef.current.includes(ref) && fileRef.current.push(ref)}
                                      // ref={fileRef}
                                      className="form-control form-h choose"
                                      type="file"
                                      accept={ele?.validation[0]?.fileTypes}
                                      id={ele?.questionId}
                                      onChange={(e) => uploadMultiChildFile(e, ele, i, idx, multiFieldEle, j)}
                                      disabled={props?.isDisable}
                                      style={isEmptyDash(multiFieldEle?.files[0]?.key) ? { display: 'block' } : { display: 'none' }}
                                    />
                                  </div>
                                  
                </div >
                              </div>
                            )}
          </>
                        ))}
        </div >
      <span id="businessNameError" className="error">{ele?.errMsg}</span>
                    </div>
  )
} */}

                </>
              ))}

              {
                (!props?.isDisable && idx == formStepFieldsDetails.sections.length - 1) ? (
                  <div className="input_group justify-content-between mt-5">
                    <button type="button" className="btn btn-outline-secondary" style={{ borderRadius: "20px" }} onClick={clearForm}>
                      Clear
                    </button>
                    <button
                      type="button"
                      className="btn btn-success save_next_btn"
                      onClick={submitForm}
                    >
                      Save & Submit
                    </button>
                  </div>
                ) : (idx == formStepFieldsDetails.sections.length - 1) && (
                  <div className="input_group justify-content-between mt-5 "><Button className="view_progress_you" onClick={() => navigateUrl('/admin/onboarding-form-status')}>View Progress</Button></div>
                )
              }

            </div >
          </div >
        </>
      ))
      }
      <FileViewerModal fileSrc={fileSrc} isOpen={isModalOpen} onClose={closeModal} />

      <MediaListModal
        isMediaListModalOpen={isMediaListModalOpen}
        closeMediaListModal={closeMediaListModal}
        uploadObj={uploadFilesObj}
        onUploadMedia={onUploadMedia}
        deleteFile={deleteFile}
        stepStatus={props?.formStepFieldsDetails?.status}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div >
  );
}

export default OnboardingStepThree;
